import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Interview, InterviewCreate, InterviewFilter } from '../data/interview';

export function createInterviewService(client: AxiosInstance) {
  return createCrudService<Interview, InterviewCreate, InterviewFilter>(
    client,
    '/hrm/Interview',
    'id',
  );
}

export type InterviewService = CrudService<Interview, InterviewCreate, InterviewFilter>;
